<template>
    <v-card class="ma-2">
        <v-card-title>Settings</v-card-title>
    </v-card>
</template>

<script>
    export default {
        name: "Settings"
    }
</script>

<style scoped>

</style>